import * as React from 'react'

import { Text, TextName } from 'sdk/text/Text'

/**
 * Renders text with bold parts marked by asterisks (*text*)
 * @param text - Text with parts to be bolded wrapped in asterisks
 * @param className - Optional className to apply to text elements
 * @returns Array of React elements with Text and TextBold components
 */
export const renderTextWithBold = (text: string, className?: string): React.ReactNode[] => {
  const parts = text.split(/(\*[^*]+\*)/)

  return parts.map((part, index) => {
    if (part.startsWith('*') && part.endsWith('*')) {
      const content = part.slice(1, -1)
      return (
        <Text key={index} type={TextName.TextBold} className={className}>
          {content}
        </Text>
      )
    }
    return (
      <Text key={index} type={TextName.Text} className={className}>
        {part}
      </Text>
    )
  })
}
